import { createContext, useContext, useState, useCallback, useEffect } from "react";


const KEY = "cot_alerts";
const DKEY = "cot_alerts_desktop";
const AlertsContext = createContext(null);

export function AlertsProvider({ children }) {
  const [alerts, setAlerts] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [desktop, setDesktop] = useState(() => {
    try {
      return localStorage.getItem(DKEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(alerts.slice(0, 30)));
    } catch {
      /* ignore */
    }
  }, [alerts]);

  const pushAlerts = useCallback(
    (items) => {
      if (!items || !items.length) return;
      const now = Date.now();
      setAlerts((prev) => {
        const mapped = items.map((a, i) => ({ id: `${now}-${i}-${a.key}`, ts: now, read: false, ...a }));
        return [...mapped, ...prev].slice(0, 30);
      });
      if (desktop && typeof Notification !== "undefined" && Notification.permission === "granted") {
        items.forEach((a) => {
          try {
            new Notification(a.title, { body: a.body });
          } catch {
            /* ignore */
          }
        });
      }
    },
    [desktop]
  );

  const markAllRead = useCallback(() => setAlerts((p) => p.map((a) => ({ ...a, read: true }))), []);
  const clearAll = useCallback(() => setAlerts([]), []);

  const toggleDesktop = useCallback(async () => {
    if (!desktop && typeof Notification !== "undefined") {
      try {
        if (Notification.permission !== "granted") await Notification.requestPermission();
      } catch {
        /* ignore */
      }
    }
    setDesktop((d) => {
      const n = !d;
      try {
        localStorage.setItem(DKEY, n ? "1" : "0");
      } catch {
        /* ignore */
      }
      return n;
    });
  }, [desktop]);

  const unread = alerts.filter((a) => !a.read).length;

  return (
    <AlertsContext.Provider value={{ alerts, unread, pushAlerts, markAllRead, clearAll, desktop, toggleDesktop }}>
      {children}
    </AlertsContext.Provider>
  );
}

export const useAlerts = () => useContext(AlertsContext);
